module.exports = __webpack_public_path__ + "media/images/illustrations/wave-starworks-3-7095a2cd9c14a484209063d6e61e37a8.svg";